let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("K6fhx")).then(() => parcelRequire('5eTse'));